<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter">
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="1">
            <div class="row p-3">
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                <label>{{ $t('common_words.farm') }} *</label>
                <br />
                <el-select
                  clearable
                  multiple
                  v-bind:collapse-tags="true"
                  @change="
                    selectAllFromSelect('cuttingReportsForm.farm_id', farms);
                    showCalendar();
                  "
                  filterable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="cuttingReportsForm.farm_id"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="(option, index) in farms"
                    class="select-primary selected-all"
                    :value="option.id"
                    :label="option.name"
                    :key="index + option.id"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3"
                v-if="isShowCalendar"
              >
                <label>{{ $t('common_words.calendar') }}</label>
                <br />
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-calendar shadow-sm"
                  size="large"
                  v-model="cuttingReportsForm.calendar_sel"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="(option, index) in calendars"
                    class="select-primary"
                    :value="option.id"
                    :label="option.name"
                    :key="index + option.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                <label>{{ $t('common_words.analyze_by') }} </label>
                <br />
                <el-select
                  clearable
                  @change="changeByInterval"
                  filterable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="cuttingReportsForm.bySel"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="option in optionsInterval"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-12 col-sm-8 col-md-4 col-lg-4 col-xl-3"
                v-if="
                  cuttingReportsForm.bySel != 'week' &&
                  cuttingReportsForm.bySel != 'year'
                "
              >
                <label>{{ $t('common_words.calendar') }}</label>
                <br />
                <el-date-picker
                  v-if="renderComponent"
                  v-model="rangeDate"
                  class="shadow-sm required-year"
                  v-bind:type="typedatepicket"
                  :picker-options="pickerOptions"
                  range-separator="-"
                  :placeholder="`${$t('common_words.select2')}...`"
                  :start-placeholder="$t('common_words.initial_date')"
                  :end-placeholder="$t('common_words.final_date')"
                >
                </el-date-picker>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-right: 0; padding-top: 32px"
                v-if="
                  cuttingReportsForm.bySel == 'week' ||
                  cuttingReportsForm.bySel == 'year'
                "
              >
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="cuttingReportsForm.year_sel_init"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(years).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-top: 32px"
                v-if="
                  cuttingReportsForm.bySel == 'week' &&
                  cuttingReportsForm.year_sel_init
                "
              >
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="cuttingReportsForm.week_sel_init"
                >
                  <el-option
                    v-for="(week, index) in years[
                      cuttingReportsForm.year_sel_init
                    ]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-top: 32px"
                v-if="
                  cuttingReportsForm.bySel == 'week' ||
                  cuttingReportsForm.bySel == 'year'
                "
              >
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="cuttingReportsForm.year_sel_end"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(years).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-top: 32px"
                v-if="
                  cuttingReportsForm.bySel == 'week' &&
                  cuttingReportsForm.year_sel_end
                "
              >
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="cuttingReportsForm.week_sel_end"
                >
                  <el-option
                    v-for="(week, index) in years[
                      cuttingReportsForm.year_sel_end
                    ]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-md-4 col-xl-2">
                <label class="label-primary" style="color: transparent">{{
                  $t('common_words.filter')
                }}</label
                ><br />
                <l-button wide type="info" class="btn-filter" @click="validate">
                  {{ $t('common_words.filter') }}
                </l-button>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </card>
      <br />
      <card
        class="custom-shadow-card-header custom-table-responsive"
        v-if="cuttingCatch"
        :title="$t('production.harvest_report')"
      >
        <div class="mt-4">
          <div class="row" v-if="isIndex()">
            <div class="custom-flex">
              <el-select
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="pagination.perPage"
                :placeholder="$t('common_words.per_page')"
                filterable
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              <el-input
                class="mb-3 shadow-sm"
                style="width: 200px"
                :placeholder="$t('common_words.search_records')"
                v-model="searchQuery"
                aria-controls="datatables"
              />
            </div>
            <div class="table-responsive">
              <table class="table table-striped table-bordered">
                <thead class="cusmtom-thead-color">
                  <tr>
                    <td
                      rowspan="3"
                      v-if="cuttingReportsForm.farm_id.length < 2"
                      class="text-center p-3"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      {{ $t('common_words.allotment') }}
                    </td>
                    <td
                      rowspan="3"
                      v-else
                      class="text-center p-3"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      {{ $t('common_words.farm') }}
                    </td>
                    <td
                      class="text-center p-3"
                      style="font-size: smaller; white-space: nowrap"
                      v-for="(column, index) in reports.columns"
                      :key="index"
                    >
                      <strong>{{ column }}</strong>
                    </td>
                    <td
                      class="text-center p-3"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      {{ $t('common_words.total') }}
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, i) in queriedData" :key="i">
                    <td class="text-center">{{ data.name }}</td>
                    <td
                      class="text-center"
                      v-for="(dataSubtotal, j) in data.dates"
                      :key="j"
                    >
                      {{
                        new Intl.NumberFormat('en-US').format(
                          dataSubtotal.total
                        )
                      }}
                    </td>
                    <td class="text-center">
                      <strong>{{
                        new Intl.NumberFormat('en-US').format(data.total)
                      }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="text-center p-3"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      {{ $t('common_words.total') }}
                    </td>
                    <td
                      class="text-center"
                      v-for="(data, j) in reports.totalXdates"
                      :key="j"
                    >
                      <strong>{{
                        new Intl.NumberFormat('en-US').format(data.total)
                      }}</strong>
                    </td>
                    <td
                      class="text-center p-3"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      <strong>{{
                        new Intl.NumberFormat('en-US').format(
                          reports.totalGeneral
                        )
                      }}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class>
                <p class="card-category">
                  {{ $t('table2.showing') }} {{ from + 1 }}
                  {{ $t('table2.a') }} {{ to }} {{ $t('table2.of') }}
                  {{ total }} {{ $t('table2.entries') }}
                </p>
              </div>
              <l-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total"
                pageFirst="false"
                pageLast="false"
              ></l-pagination>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
          <div class="row" style="padding-right: 13px; padding-left: 13px">
            <div class="col-6" v-if="isPDF()">
              <div class="text-right">
                <button
                  class="btn btn-danger custom-shadow-btn"
                  @click="exportToPDF()"
                >
                  <em class="fa fa-file-pdf-o"></em>
                  {{ $t('common_words.export_to_pdf') }}
                </button>
              </div>
            </div>
            <div class="col-6" v-if="isExcel()">
              <div class="text-left">
                <button
                  class="btn custom-btn-success custom-shadow-btn"
                  @click="exportExcel()"
                >
                  <em class="fa fa-file-excel-o"></em>
                  {{ $t('common_words.export_to_excel') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </card>
      <br />
      <card
        class="custom-shadow-card-header custom-table-responsive"
        v-if="cuttingCatch"
        :title="$t('production.denegation_report')"
      >
        <div class="mt-4">
          <div class="row" v-if="isIndex()">
            <div class="custom-flex">
              <el-select
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="pagination2.perPage"
                :placeholder="$t('common_words.per_page')"
                filterable
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination2.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              <el-input
                class="mb-3 shadow-sm"
                style="width: 200px"
                :placeholder="$t('common_words.search_records')"
                v-model="searchQuery2"
                aria-controls="datatables"
              />
            </div>
            <div class="table-responsive">
              <table
                aria-describedby="tabla-recusados"
                class="table table-striped table-bordered"
              >
                <thead class="cusmtom-thead-color">
                  <tr>
                    <td
                      rowspan="3"
                      v-if="cuttingReportsForm.farm_id.length < 2"
                      class="text-center p-3"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      {{ $t('common_words.allotment') }}
                    </td>
                    <td
                      rowspan="3"
                      v-else
                      class="text-center p-3"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      {{ $t('common_words.farm') }}
                    </td>
                    <th
                      scope="col"
                      class="text-center p-3 custom-header-label"
                      v-bind:style="{ minWidth: '220px' }"
                    >
                      <strong>{{ $t('production.denegation_motive') }}</strong>
                    </th>
                    <td
                      class="text-center p-3"
                      style="font-size: smaller; white-space: nowrap"
                      v-for="(column, index) in reports2.columns"
                      :key="index"
                    >
                      <strong>{{ column }}</strong>
                    </td>
                    <td
                      class="text-center p-3"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      {{ $t('common_words.total') }}
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, i) in queriedData2" :key="i">
                    <td class="text-center">{{ data.name }}</td>
                    <td class="text-center">{{ data.rejection }}</td>
                    <td
                      class="text-center"
                      v-for="(dataSubtotal, j) in data.dates"
                      :key="j"
                    >
                      {{
                        new Intl.NumberFormat('en-US').format(
                          dataSubtotal.total
                        )
                      }}
                    </td>
                    <td class="text-center">
                      <strong>{{
                        new Intl.NumberFormat('en-US').format(data.total)
                      }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td
                      colspan="2"
                      class="text-center p-3"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      {{ $t('common_words.total') }}
                    </td>
                    <td
                      class="text-center"
                      v-for="(data, j) in reports2.totalXdates"
                      :key="j"
                    >
                      <strong>{{
                        new Intl.NumberFormat('en-US').format(data.total)
                      }}</strong>
                    </td>
                    <td
                      class="text-center p-3"
                      style="font-weight: bolder; font-size: 14px"
                    >
                      <strong>{{
                        new Intl.NumberFormat('en-US').format(
                          reports2.totalGeneral
                        )
                      }}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class>
                <p class="card-category">
                  {{ $t('table2.showing') }} {{ from + 1 }}
                  {{ $t('table2.a') }} {{ to }} {{ $t('table2.of') }}
                  {{ total }} {{ $t('table2.entries') }}
                </p>
              </div>
              <l-pagination
                class="pagination-no-border"
                v-model="pagination2.currentPage"
                :per-page="pagination2.perPage"
                :total="pagination2.total"
                pageFirst="false"
                pageLast="false"
              ></l-pagination>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
          <div class="row" style="padding-right: 13px; padding-left: 13px">
            <div class="col-6" v-if="isPDF()">
              <div class="text-right">
                <button
                  class="btn btn-danger custom-shadow-btn"
                  @click="exportToPDF('rejection')"
                >
                  <em class="fa fa-file-pdf-o"></em>
                  {{ $t('common_words.export_to_pdf') }}
                </button>
              </div>
            </div>
            <div class="col-6" v-if="isExcel()">
              <div class="text-left">
                <button
                  class="btn custom-btn-success custom-shadow-btn"
                  @click="exportExcel('rejection')"
                >
                  <em class="fa fa-file-excel-o"></em>
                  {{ $t('common_words.export_to_excel') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';
import { Pagination as LPagination } from 'src/components/index';
import paginationData from './paginationData';
import Fuse from 'fuse.js';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinDatePicker from 'src/util/mixinDatePicker';
import mixinMasters from 'src/util/mixinMasters';
import { MixinExport } from 'src/mixins/mixin-export';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import { RadioGroup, Radio, RadioButton } from 'element-ui';
import i18n from 'src/i18n';

export default {
  components: {
    LPagination,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [RadioButton.name]: RadioButton,
  },
  computed: {
    calendars() {
      if (this.cuttingReportsForm.farm_id) {
        let calendars = [];
        this.farms.forEach((element) => {
          this.cuttingReportsForm.farm_id.forEach((elFarm) => {
            if (element.id != 0 && element.id == elFarm) {
              calendars = element.calendars;
            }
          });
        });

        return calendars;
      } else {
        return [];
      }
    },
    optionsInterval() {
      return {
        0: { label: this.$i18n.t('common_words.day'), value: 'daterange' },
        1: { label: this.$i18n.t('common_words.week'), value: 'week' },
        2: { label: this.$i18n.t('common_words.month'), value: 'monthrange' },
        3: { label: this.$i18n.t('common_words.year'), value: 'year' },
      };
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    ...paginationData.functions,
  },
  data() {
    return {
      cuttingReportsForm: {
        farm_id: [],
        year_sel_init: null,
        week_sel_init: null,
        year_sel_end: null,
        week_sel_end: null,
        bySel: null,
        year_sel: null,
        calendar_sel: null,
        user_id: this.$store.state.auth.user.id,
      },
      searchQuery: '',
      searchQuery2: '',
      fuseSearch: null,
      fuseSearch2: null,
      pagination: paginationData.pagination,
      pagination2: paginationData.pagination2,
      typedatepicket: 'daterange',
      row: null,
      activeName: '1',
      valueCollapse: null,
      reports: [],
      reports2: [],
      interval: 'Semana',
      years: [],
      farms: [],
      cuttingCatch: false,
      isShowCalendar: false,
    };
  },
  mixins: [
    MixinPermissions,
    MixinDatePicker,
    mixinMasters,
    MixinExport,
    MixinMenu,
  ],

  watch: {
    '$i18n.locale': ['forceRerender', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.farms = this.concatAll(this.farms.splice(1));
    },
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    changeByInterval() {
      this.cuttingCatch = false;
      for (
        let index = 0;
        index < Object.values(this.optionsInterval).length;
        index++
      ) {
        const element = Object.values(this.optionsInterval)[index];
        if (element.label == this.cuttingReportsForm.bySel) {
          this.typedatepicket = element.value;
          break;
        }
      }
    },
    handleCollapse(val) {
      this.valueCollapse = val;
    },
    showCalendar() {
      this.isShowCalendar = true;
      this.cuttingReportsForm.calendar_sel = null;
      this.cuttingCatch = false;

      for (let index = 0; index < Object.values(this.farms).length; index++) {
        const element = Object.values(this.farms)[index];

        this.cuttingReportsForm.farm_id.forEach((elFarm) => {
          if (element.id != 0 && element.id == elFarm) {
            if (element.calendars.length > 1) {
              this.isShowCalendar = true;
              this.cuttingReportsForm.calendar_sel = null;
            } else {
              if (element.calendars.length == 1) {
                this.cuttingReportsForm.calendar_sel = element.calendars[0].id;
                this.isShowCalendar = false;
              }
            }
          }
        });
      }

      this.isShowCalendar = false;
    },
    validate() {
      if (
        this.cuttingReportsForm.farm_id == null ||
        this.cuttingReportsForm.farm_id.length == 0
      ) {
        return this.validationInputsRequired('farm');
      } else if (
        (this.cuttingReportsForm.bySel == 'year' &&
          (this.cuttingReportsForm.year_sel_init == null ||
            this.cuttingReportsForm.year_sel_end == null)) ||
        (this.cuttingReportsForm.bySel == 'week' &&
          this.isYearSelRequired() &&
          this.cuttingReportsForm.year_sel_init == null)
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.isWeekSekRequired() &&
        this.cuttingReportsForm.week_sel_init == null &&
        this.cuttingReportsForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
      } else if (
        this.isYearSelRequired() &&
        this.cuttingReportsForm.year_sel_end == null &&
        this.cuttingReportsForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.isWeekSekRequired() &&
        this.cuttingReportsForm.week_sel_end == null &&
        this.cuttingReportsForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
      } else if (this.cuttingReportsForm.calendar_sel == null) {
        SweetAlert.warning(i18n.t('common_words.no_associated_calendars'));
      } else if (this.rangeDate == null) {
        return this.validationInputsRequired('year');
      } else {
        this.loadCuttingReport();
      }
    },

    loadCuttingReport() {
      this.showHideLoading(true);
      let data = this.loadData();
      data.route = 'cutting/reports';

      Axios.postMasters(data)
        .then((response) => {
          if (response.data) {
            const [cuttingResponse, rejectionsResponse] = response.data;
            this.reports = cuttingResponse;
            this.reports2 = rejectionsResponse;

            this.fuseSearch = new Fuse(this.reports.tableData, {
              useExtendedSearch: true,
              threshold: 0.3,
              keys: ['name', 'total', 'dates.total'],
            });

            this.fuseSearch2 = new Fuse(this.reports2.tableData, {
              useExtendedSearch: true,
              threshold: 0.3,
              keys: ['name', 'rejection', 'total', 'dates.total'],
            });
            this.cuttingCatch = true;
          }

          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
        });
    },

    loadData() {
      let data = {
        farm: this.cuttingReportsForm.farm_id,
        init:
          parseInt(this.cuttingReportsForm.year_sel_init) * 100 +
          parseInt(this.cuttingReportsForm.week_sel_init),
        end:
          parseInt(this.cuttingReportsForm.year_sel_end) * 100 +
          parseInt(this.cuttingReportsForm.week_sel_end),
        bySel: this.cuttingReportsForm.bySel,
      };

      switch (this.cuttingReportsForm.bySel) {
        case 'year':
          data.init = this.cuttingReportsForm.year_sel_init;
          data.end = this.cuttingReportsForm.year_sel_end;
          break;
        case 'monthrange':
          data.init = moment(this.rangeDate[0]).format('YYYY-MM-DD');
          data.end = moment(this.rangeDate[1]).format('YYYY-MM-DD');
          break;
        case 'week':
          data.init = `${this.cuttingReportsForm.year_sel_init}-${(
            '0' + this.cuttingReportsForm.week_sel_init
          ).slice(-2)}`;
          data.end = `${this.cuttingReportsForm.year_sel_end}-${(
            '0' + this.cuttingReportsForm.week_sel_end
          ).slice(-2)}`;
          break;
        case 'daterange':
          data.init = moment(this.rangeDate[0]).format('YYYY-MM-DD');
          data.end = moment(this.rangeDate[1]).format('YYYY-MM-DD');
          break;
      }

      return data;
    },

    isYearSelRequired() {
      return this.interval == 'week';
    },

    isWeekSekRequired() {
      return this.interval == 'week';
    },

    exportToPDF(type = 'cutting') {
      let data = this.loadData();
      data.route =
        'cutting/reports/pdf/' + (type == 'cutting' ? '' : 'rejections');
      data.name_file =
        type === 'cutting'
          ? `${i18n.t('production.harvest_report')}.pdf`
          : `${i18n.t('production.denegation_report')}.pdf`;

      this.PDF(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportExcel(type = 'cutting') {
      let data = this.loadData();
      data.route =
        'cutting/reports/excel/' + (type == 'cutting' ? '' : 'rejections');
      data.name_file =
        type === 'cutting'
          ? `${i18n.t('production.harvest_report')}.xlsx`
          : `${i18n.t('production.denegation_report')}.xlsx`;

      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);

      Axios.getMasters('farms/farms/onlyfruit')
        .then((response) => {
          this.farms = this.concatAll(response.data.data);
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }

    Axios.getMasters('calendars/getyearsbusiness').then((response) => {
      this.years = response.data;
      this.showHideLoading();
    });

    let current = new Date();
    this.rangeDate = [
      new Date(current.setDate(current.getDate() - current.getDay())),
      new Date(current.setDate(current.getDate() - current.getDay() + 6)),
    ];
  },

  mounted() {
    this.selectedItemOnMenu('cutting');
  },

  destroyed() {
    this.deselectedItemOnMenu('cutting');
  },
};
</script>
